export enum StorageKeys {
  MobileHelpScreenShown = 'mobile-help-screen-shown',
  LocalSettings = 'local-settings',
}
